define('ordersBoardView',[
  'app',
  'module',
  'jquery',
  'backbone',
  'marionette',
  'underscore',
  'ordersBoardHeaderView',
  'ordersBoardFiltersView',
  'ordersBoardKanbanView',
  'ordersBoardFiltersLanguageView',
  'template!ordersBoardView',
  'entities/sales_inbox'
], function (
  App,
  Module,
  $,
  Backbone,
  Marionette,
  _,
  HeaderView,
  FiltersView,
  KanbanView,
  LanguageFilterView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'orders-board-view',

    regions: {
      filtersRegion: '.filters-region',
      headerRegion: '.header-region',
      kanbanRegion: '.kanban-region'
    },

    // Orders/offers past their status's "need check" delay, by poi — the cards
    // put a clock on them. Reloaded every few minutes, and the
    // cards redraw on 'status-checks:changed'. A failure (no access) simply
    // means no clocks.
    loadStatusChecks: function () {
      var self = this;
      var defer = $.Deferred();
      App.request('salesInbox:status-checks').done(function (checks) {
        var byPoi = {};
        _.each(checks || [], function (c) {
          if (c && c.purchaseOrderId) { byPoi[c.purchaseOrderId] = c; }
        });
        defer.resolve(byPoi);
      }).fail(function () {
        defer.resolve({});
      });
      this.statusChecks = defer.promise();
      defer.done(function () {
        if (!self.isDestroyed) { self.trigger('status-checks:changed'); }
      });
    },

    onDestroy: function () {
      if (this.statusChecksTimer) { window.clearInterval(this.statusChecksTimer); }
    },

    onShow: function () {
      // Orders and offers boards both: a status delay can be set on either.
      if (this.options.type === 'command' || this.options.type === 'offer') {
        this.loadStatusChecks();
        this.statusChecksTimer = window.setInterval(_.bind(this.loadStatusChecks, this), 5 * 60 * 1000);
      }

      this.headerView = new HeaderView({
        boardView: this,
        type: this.options.type
      });
      this.getRegion('headerRegion').show(this.headerView);

      //-------------------
      this.filtersView = new FiltersView({
        boardView: this,
        type: this.options.type,
        endUserId: this.options.endUserId
      });
      this.getRegion('filtersRegion').show(this.filtersView);

      //-------------------
      this.languageFilterView = new LanguageFilterView({
        boardView: this,
        filters: this.filtersView.model
      });

      // Apply initial language filter to model before kanban is created
      if (this.languageFilterView.hasLanguages()) {
        this.listenTo(this.languageFilterView, 'language:change', this.onLanguageFilterChange);
        
        // Show language filter in the filters banner quick access region
        this.filtersView.$el.find('.body').prepend('<div class="language-filter-region"></div>');
        this.filtersView.$el.find('.language-filter-region').append(this.languageFilterView.render().$el);
        this.languageFilterView.triggerMethod('show');

        // Set initial webshop filter on model (without triggering fetch yet)
        var initialWebshops = this.languageFilterView.getSelectedWebshops();
        if (initialWebshops.length > 0) {
          var webshopValue = initialWebshops.join(',');
          this.filtersView.model.set('webshop', webshopValue);
        }
      }

      //-------------------
      this.kanbanView = new KanbanView({
        boardView: this,
        parentStatus: this.options.parentStatus,
        type: this.options.type,
        filtersView: this.filtersView
      });
      this.getRegion('kanbanRegion').show(this.kanbanView);
    },

    onLanguageFilterChange: function (webshops) {
      var webshopValue = Array.isArray(webshops) ? webshops.join(',') : webshops;
      this.filtersView.model.set('webshop', webshopValue);
      this.filtersView.fetchWithoutStore(this.filtersView.model);
      this.filtersView.trigger('change', this.filtersView.model);
    }
  });
});
  
